
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","id":"Megaphone--Streamline-Streamline--3.0.svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Megaphone Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('megaphone')]),_c('path',{attrs:{"d":"M6.75 15.25H4.5a3.75 3.75 0 0 1 0 -7.5h2.25Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6.75 15.25a22.3 22.3 0 0 1 12.366 3.744l1.134 0.756V3.25l-1.134 0.756A22.3 22.3 0 0 1 6.75 7.75Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m23.25 10 0 3","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6.75 15.25A7.239 7.239 0 0 0 9 20.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    